<template>
  <div class="q-multiple-container main-color">
    <label class="q-multiple-label q-label" v-html="question.q"></label>
    <div class="q-multiple-answer-container">
      <md-checkbox v-model="answer" :disabled="readOnly" v-for="option in question.answers" @change="emitValueMultiOptions"  :key="option.value" :value="option.value">{{ option.value }}</md-checkbox>
    </div>
    <div v-show="question.other_option == true">
      <md-checkbox v-model="answerOtherOption" :disabled="readOnly"  @change="emitValueMultiOptions"  :key="otherOption" :value="otherOption">{{ otherOption }}</md-checkbox>
      <md-input
        :placeholder="'Tu otra opción'"
        type="text"
        :disabled="readOnly"
        v-model="answerOther"
        v-if="answerOtherOption.includes(otherOption)"
        @change="emitValueMultiOptions"
      ></md-input>
    </div>
    <div v-show="question.no_choice == true">
      <md-checkbox v-model="answerNoOne" :disabled="readOnlyNoChoice"  @change="noOneSelected"  :key="noOneOptions" :value="noOneOptions">{{ noOneOptions }}</md-checkbox>
    
    </div>
  </div>
</template>

<script>
export default {
  name: "multiple-options-question",
  props: {
    question: {
      type: Object,
      default: () => {
        return {};
      }
    },
    answerProp:{
      type: Array,
      default: () => {
        return [];
      }
    },
    readOnly:{
      type:Boolean,
      default: false
    }
  },
   methods: {
    emitValueMultiOptions: function() {
      //console.log(this.answer);
      let ansMulti = "";
      this.answer.forEach(function (item) {
        if (ansMulti === "") {
          ansMulti = item;
        } else {
          ansMulti = ansMulti + "," + item;
        }
      });
      if(this.answerOtherOption.includes(this.otherOption) == false){
        this.answerOther = "";
      }
      if(this.answerOther != ""){
        if (ansMulti === "") {
          ansMulti = this.answerOther;
        } else {
          ansMulti = ansMulti + "," + this.answerOther;
        }
      }
      console.log(ansMulti);
      this.$emit("emit-value", { "q_id": this.question.q_id, "q_type": this.question.q_type, "ans": ansMulti });
    },
    noOneSelected: function(val){
      if(val){
        this.answerOther = '';
        this.answer = [this.noOneOptions];
        this.emitValueMultiOptions();
        this.readOnly = true;
        this.answerOtherOption = [];
      }
      else{
        var index = this.answer.indexOf(this.noOneOptions);
        this.answer.splice(index,1);
        this.emitValueMultiOptions();
        this.readOnly = false;
      }
    }
  },
   mounted: function() {
    //console.log(this.question.answers);
    //console.log(this.answerProp);
    let ans = [];
    let ansProp = this.answerProp;
    this.question.answers.forEach(function(element){
      //console.log(element);
      if(ansProp.includes(element.value.toUpperCase())){
        ans.push(element.value);
      }
      });
    
    //console.log(ans);
    this.answer = ans;
  },
  data: function() {
    return {
      answer: [],
      answerOther: '',
      answerNoOne: '',
      answerOtherOption: [],
      otherOption: 'Otro',
      noOneOptions: 'Ninguna de las anteriores',
      readOnlyNoChoice : false
    };
  }
};
</script>

<style lang="scss" scoped>
  .md-checkbox {
    display: flex;
  }
</style>

